import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

const usePersistBetSlip = () => {
  const dispatch = useDispatch<Dispatch>();
  const hasHydrated = useRef(false);

  useEffect(() => {
    if (!hasHydrated.current) {
      hasHydrated.current = true;
      dispatch.betSlip.rehydrateBetslip();
    }
  }, [dispatch.betSlip]);
};

export default usePersistBetSlip;
